<template>
    <div>
        <div v-if="mode" :class="classname">
            <div :key="id" v-for="(item,id) in options" :class="rClass[id>rNum?1:0]">
                <el-radio v-model="inputvalue"
                          @change="setStatus"
						  v-if="!hideLov.includes(item.val)"
						  :disabled="disabled || disabledLov.includes(item.val)"
                          :label="item.val"
                          :key="item.id">
                    <span v-text="item.name"></span>
                </el-radio>
            </div>
        </div>
        <div v-if="!mode">
            <el-radio @change="setStatus" v-for="item in options"
					  v-if="!hideLov.includes(item.val)"
					  v-model="inputvalue"
					  :disabled="disabled || disabledLov.includes(item.val)"
                      :label="item.val"
                      :key="item.id">{{item.name}}
            </el-radio>
        </div>
    </div>
</template>

<script>
    /*
   @name:值列表单选组件
   @createdby:黄安邦
   @example template: <lnk-lov-radio @setlovvalue="getStatus"  v-model="teststatus"
    lov="ACCT_STAGE"
    :exclude-lov=['New']
    parent-lov-type="ACCT_TYPE"
    parent-lov-value="Consumer"
   ></lnk-lov-radio>
   @setlovvalue: 作为可选项，如果还需要获取该lov对象的其他信息，可以用。否则可不适用。
   自定义样式属性（可选）：classname（组件的class名），
                           radio-class（radio容器的class名），
                           paddingClass（换行后redio容器的class名，需要指定row-num属性），
                           row-num（指定一行的redio数量）
   @example js:
   data: teststatus:'已提交',
   methods: getStatus:function(s){
           if (s!=''){
               var obj = JSON.parse(s);
               this.teststatus=obj.name;
           }else{
               this.teststatus='';
           }
       },
   * */
    export default {
        name: "lnk-lov-radio",
        data: function () {
            return {
                options: [], // 可选项
                inputvalue: '', // 当前的值
                rNum: 10000000, // 一行的个数
                mode: false, // 是否自定义样式，默认为false
                rClass: ['', '']
            };
        },
        props: {
            // parentval: String,//父亲值列表的独立源代码
            value1: String, // 外部传输的值
            lov: String, // 值列表的类型
            excludeLov: Array, // 排除的值列表
            parentLovType: String,
            parentLovValue: String,
            disabled: Boolean, // 是否禁用
            /* 样式注入*/
            classname: String, // 组件的class名，
            radioClass: String, // radio容器的class名
            paddingClass: String, // 大于一行时，radio附加的class,仅在属性row-num设置为数字时有效
            rowNum: Number,// 指定一行的redio数量
			hideLov: {type: Array, default: () => []},   // 隐藏的值列表
			disabledLov: {type: Array, default: () => []}, // 禁用掉的值列表
            /* 样式注入*/
        },
        model: {
            prop: 'value1',
            event: 'innerChange'

        },
        mounted: function () {
            this.initStyle();
            this.getstatus();
        },
        watch: {
            value1: {
                immediate: true,
                handler: function () {
                    if (this.value1) {
                        this.inputvalue = this.value1;
                    }
                }
            },
            // 值列表类型相关发生改变，清空选中值
            parentLovType: function () {
                this.$emit('innerChange', '');
                this.getstatus();
            },
            parentLovValue: function () {
                this.$emit('innerChange', '');
                this.getstatus();
            },
            lov: function () {
                this.$emit('innerChange', '');
                this.getstatus();
            }
        },
        methods: {
            setStatus: function () {
                this.$emit('innerChange', this.inputvalue);
                for (let i = 0; i < this.options.length; i++) {
                    if (this.inputvalue == this.options[i].val) {
                        this.$emit('setlovvalue', JSON.stringify(this.options[i]));
                        return;
                    }
                }
                this.$emit('setlovvalue', '');
            },
            getstatus: async function () {
                // 获取值列表

                /*if (this.parentLovType) {
                    // console.log(linkLov.getSubLovArray(this.parentLovType, this.parentLovValue, this.lov));
                    this.options = linkTools.deepCopy(linkLov.getSubLovArray(this.parentLovType, this.parentLovValue, this.lov));
                    if (this.excludeLov) {
                        this.options = linkTools.excludeLov(this.options, this.excludeLov);
                    }
                } else {
                    this.options = linkTools.deepCopy(linkLov.getLovArray(this.lov));
                    if (this.excludeLov) {
                        this.options = linkTools.excludeLov(this.options, this.excludeLov);
                    }
                }
                if (!this.value1) {
                    for (let i = 0; i < this.options.length; i++) {
                        if(this.options[i].defaultValue === 'Y'){
                            this.inputvalue = this.options[i].val;
                            this.$emit('innerChange', this.inputvalue);
                            return;
                        }
                    }
                }*/
                const {lovs, defaultVal} = await this.$lov.getLovData(this.lov, this.parentLovType, this.parentLovValue, this.excludeLov, false)
                this.options = lovs
                if (!this.value1 && !!defaultVal) {
                    this.inputvalue = defaultVal;
                    this.$emit('innerChange', this.inputvalue);
                }
            },
            initStyle: function () { // 初始化自定义样式配置
                if (this.classname || this.radioClass || this.paddingClass && this.rowNum) {
                    this.mode = true;
                    if (this.radioClass) this.rClass = [this.radioClass, this.radioClass];
                    if (this.paddingClass) {
                        this.rClass[1] += ' ' + this.paddingClass;
                    }
                    if (this.rowNum && !isNaN(this.rowNum)) {
                        this.rNum = parseInt(this.rowNum) - 1;
                    }
                }
            }
        }
    };
</script>
